interface OffersProps {
	offer: {
		heading: string;
		price: string;
		desc: string;
	};
	index: number;
}

const Offer: React.FC<OffersProps> = ({ offer, index }) => {
	return (
		<div className='offer'>
			<svg
				className='offer_icon'
				xmlns='http://www.w3.org/2000/svg'
				width='57'
				height='57'
				viewBox='0 0 57 57'
				fill='none'>
				<path
					d='M5.39043 40.5952C6.15683 38.7363 5.02684 37.5161 3.37641 35.9926C-1.59985 31.4079 -0.958217 24.0401 4.52779 19.9513C5.39756 19.302 5.62214 18.7168 5.50094 17.6108C4.6276 9.70075 10.2669 4.35603 18.1341 5.44067C18.6795 5.51559 19.5136 4.98041 19.9021 4.4809C22.7753 0.805964 26.4219 -0.703251 31.0167 0.306465C33.569 0.866625 35.5332 2.36158 37.0232 4.45593C37.6434 5.3265 38.171 5.6155 39.3402 5.4157C46.6371 4.17407 52.7469 10.3715 51.4921 17.6893C51.3103 18.7418 51.6205 19.2948 52.4296 19.8978C58.5038 24.4219 58.5288 32.5068 52.4724 36.9916C51.5884 37.6481 51.3175 38.2439 51.5135 39.3571C52.7897 46.5821 46.5301 52.7724 39.2261 51.4951C38.2352 51.3203 37.7361 51.5165 37.1587 52.2729C32.3856 58.556 24.636 58.5774 19.8701 52.3265C19.314 51.595 18.872 51.2953 17.8382 51.4809C11.1331 52.6904 5.40469 47.8131 5.39043 40.5952ZM21.9162 38.2903C22.3404 38.0085 23.2101 37.6089 23.8518 36.9738C28.2827 32.6067 32.6672 28.1896 37.0588 23.7797C37.3904 23.4479 37.6969 23.0732 37.9286 22.6665C38.5952 21.4927 38.4419 20.3331 37.5044 19.4161C36.5669 18.4992 35.412 18.3672 34.2499 19.0629C33.8471 19.302 33.4764 19.6124 33.1448 19.9442C28.7389 24.3398 24.3401 28.7391 19.952 33.1526C19.5813 33.5272 19.232 33.9553 18.9932 34.4192C18.0877 36.2031 19.4494 38.3403 21.9162 38.2903ZM21.3209 24.9285C23.3527 24.9571 24.9675 23.4122 25.0103 21.3963C25.0531 19.3983 23.4704 17.7713 21.4492 17.7357C19.3603 17.7 17.8525 19.17 17.8275 21.2643C17.8061 23.3836 19.2498 24.9 21.3209 24.9285ZM35.608 39.2001C37.6327 39.2144 39.244 37.6517 39.2725 35.6429C39.2974 33.6414 37.7112 32.0322 35.6864 32.0108C33.5976 31.9894 32.1075 33.463 32.0933 35.568C32.0719 37.6802 33.5298 39.1823 35.608 39.2001Z'
					fill={`url(#paint0_linear_4_${index})`}
				/>
				<defs>
					<linearGradient
						id={`paint0_linear_4_${index}`}
						x1='5.34375'
						y1='-5.60714e-07'
						x2='28.5'
						y2='57'
						gradientUnits='userSpaceOnUse'>
						<stop className='stop1' />
						<stop offset='1' className='stop2' />
					</linearGradient>
				</defs>
			</svg>
			<div
				className='d-flex flex-column'
				style={{
					position: 'relative'
				}}>
				<div className='heading'>{offer?.heading}</div>
				<div className='offer_price'>{offer?.price}</div>
				<div className='text-14 text-grey900 fw-400'>{offer?.desc}</div>
				<div className='shape_top' />
				<div className='shape_bottom' />
			</div>
		</div>
	);
};

export default Offer;
